<template>
	<div class="no-scrollbar">
		<AuthLoading v-if="loading" />
		<router-view v-else />
		<LoginPromptDialog v-model="showLoginDialog" :intended-route="intendedRoute" @login-success="onLoginSuccess"
			@cancelled="onCancelled" />
		<InvalidTokenDialog v-model="showInvalidTokenDialog" :error-type="errorType" @closed="onInvalidTokenClosed"
			@request-new-link="onRequestNewLink" />
	</div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuth } from './composables/useAuth.js'
import { useLoginDialog } from './composables/useLoginDialog.js'
import { useInvalidTokenDialog } from './composables/useInvalidTokenDialog.js'
import AuthLoading from './components/AuthLoading.vue'
import LoginPromptDialog from './components/LoginPromptDialog.vue'
import InvalidTokenDialog from './components/InvalidTokenDialog.vue'

const { checkAuth, loading: authLoading, checkCountDown, checkNextWeekDetails, getWeekly_prize_info, getYear } = useAuth()
const { showLoginDialog, intendedRoute, onLoginSuccess, onCancelled } = useLoginDialog()
const { showInvalidTokenDialog, errorType, onClosed: onInvalidTokenClosed, onRequestNewLink } = useInvalidTokenDialog()
const loading = ref(true)

onMounted(async () => {
	await checkAuth()
	await checkCountDown()
	await checkNextWeekDetails()
	await getWeekly_prize_info()
	await getYear()
	checkForLoginErrors()

	setTimeout(() => {
		loading.value = false
	}, 500)
})

const checkForLoginErrors = () => {
	const urlParams = new URLSearchParams(window.location.search)
	const loginError = urlParams.get('login_error')

	if (loginError) {
		const errorTypeMapping = {
			'invalid_token': 'invalid_token',
			'expired_token': 'expired_token',
			'already_verified': 'already_verified'
		}

		const mappedErrorType = errorTypeMapping[loginError] || 'invalid_token'

		const { showDialog } = useInvalidTokenDialog()
		showDialog(mappedErrorType)

		urlParams.delete('login_error')
		const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '') + window.location.hash
		window.history.replaceState({}, '', newUrl)
	}
}
</script>
